module.exports = __webpack_public_path__ + "img/blue-fox.08def16e.jpg";